import React from 'react'
import { WallboxModel } from '../../wallboxes'
import { Button, Stack } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useModals from 'src/Hooks/useModals'
import { ChargingCardModel } from '../api/models/charging-card-model'

interface ShowLinkedWallboxesButtonProps {
  linkedWallboxes: WallboxModel[]
  chargingCard: ChargingCardModel
  installationId: number
}

/**
 * Button component rendered inside the "Linked wallboxes" cell of Charging card table.
 *
 * At the moment, when there are 3+ wallboxes linked to a single charging card, we do not display wallbox names or
 * wallbox ids of those wallboxes, but instead this button with the label "Show linked wallboxes (3+)". The button is
 * wired to open a dialog where all(up to 8) wallboxes are displayed in a list.
 */
export const ShowLinkedWallboxesButton: React.FC<ShowLinkedWallboxesButtonProps> = ({ linkedWallboxes, chargingCard, installationId }) => {
  const { t } = useCustomTranslation()
  const { openLinkedWallboxesOverviewDialog } = useModals()

  return (
    <Stack direction="row">
      <Button
        variant="outlined"
        onClick={event => {
          event.stopPropagation()
          openLinkedWallboxesOverviewDialog({ linkedWallboxes, chargingCard })
        }}
        sx={{
          /**
           * Super important! muiTheme has limited the default height of Button, but this leads to label moving out of the
           * Button body when the label is long and there is limited horizontal space(here it is a table cell).
           *
           * In Dutch, the label "Gekoppelde wanddozen weergeven (15)" would break into three rows and only the middle one
           * would be positioned inside the Button outline. For this reason, we revert to the default behavior of MUI Button
           * and allow the Button to grow.
           */
          maxHeight: 'unset',
        }}
      >
        {t('emobility.wallbox.show-linked-wallboxes-with-count', { wallboxCount: linkedWallboxes.length })}
      </Button>
    </Stack>
  )
}
